<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">项目付款支付申请表</h2>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <el-form-item label="需求类型">
            <el-radio-group :disabled="hasApplyId" v-model="contractType" class="type-radio-type">
              <el-radio-button label="1">工程集团审批</el-radio-button>
              <el-radio-button label="2">工程子公司内部审批</el-radio-button>
              <el-radio-button label="3">材料和设备(含采购、服务)</el-radio-button>
              <el-radio-button label="4">资金使用申请(原水)</el-radio-button>
            </el-radio-group>
          </el-form-item>


          <create-pay-approval :hasApplyId="hasApplyId" v-if="contractType==1||contractType==2" ref="create"
            :project="project" :userData="userData" :formByFather="form">
          </create-pay-approval>
          <create-asset-pay-approval :hasApplyId="hasApplyId" v-if="contractType==3" ref="create" :userData="userData"
            :formByFather="form">
          </create-asset-pay-approval>
          <create-pay-ys-approval v-if="contractType==4" :hasApplyId="hasApplyId" ref="create" :userData="userData"
            :formByFather="form">
          </create-pay-ys-approval>


          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments :projectId="form.projectId" :contractId="form.contractId" ref="attachments"
                :arr="attachmentArr" :type='14'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item ref="approval" :approvalUsers="approvalUsersData" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>

          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button :loading="formLoading" @click="createProject()" class="form-btn" type="success">确认提交项目付款支付申请表
              </el-button>
            </div>
          </el-form-item>

        </el-form>
      </el-col>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import Attachments from '@/components/Attachments'
  import approvalUsers from '@/Mixins/approvalUsers'

  import ApprovalItem from '@/components/ApprovalItem'
  import CreatePayApproval from '@/page/form/createPayApproval'
  import CreateAssetPayApproval from '@/page/form/createAssetPayApproval'
  import CreatePayYsApproval from '@/page/form/createPayYsApproval'
  export default {
    components: {
      ApprovalItem,
      CreatePayApproval,
      Attachments,
      CreateAssetPayApproval,
      CreatePayYsApproval,
    },
    mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        hasApplyId: '',
        contractType: '',
        remark: '',

        project: {},
        form: {
          isAlone: true,
          isSinglePay: 1,

          name: '',
          payTypeId: '',
          projectId: '',
          bcjk: '',
          bqshjk: '',
          bqzf: '',
          fkdw: '',
          htdf: '',
          htjk: '',
          htmc: '',
          jbr: '',
          kxlb: '',
          ljzfjk: '',
          wtfs: '',
          xmgldw: '',
          zfqs: '',
          zfzshzj: '',
          remark: '',


          // 材料设备采购新增
          htqx: '',
          cgfs: '',
          bcht1: 0,
          bcht2: 0,
          ywchtje: '',
          bqcgje: '',

          // 支付审批对象
          type: 0,

          // 是否线下审批通过
          underLine: "",
        },
        // 附件
        // attachments: "",

        approvalUsersData: "",
        isYuanshui: false,
        // approvalUsers.c14

        // 审批
        approvalType: "0",
        formLoading: false,

        applyInfo: '',
        attachmentArr: [],

        approvalByPay: true,
      }
    },
    created() {
      this.contractType = 1
    },
    mounted() {
      if (this.$route.params.projectId) {
        this.form.projectId = this.$route.params.projectId / 1
      }
      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
      }
      if (this.$route.query.projectId) {
        this.form.projectId = this.$route.query.projectId / 1
      }
      // console.log(this.$route.query)

      this.form.fkdw = this.userData.department.split('/')[0]

      this.approvalUsersData = this.approvalUsers['c14_' + this.form.type]
      this.getApplyData()


      if (this.userData.deptDetail) {
        // 原水
        this.form.type = 1
      } else {
        this.form.type = 0
      }
    },
    methods: {
      // setApprovalUser() {
      //   // 如果微型项目，默认子公司审批
      //   if (this.project.type == 3 || this.project.type == 4) {
      //     this.contractType = 2;
      //   } else {
      //     this.contractType = 1;
      //     if (this.userData.deptDetail) {
      //       // 原水
      //       this.form.type = 1
      //     } else {
      //       this.form.type = 0
      //     }
      //   }
      //   this.approvalUsersData = this.approvalUsers['c14_' + this.form.type]

      //   this.getApplyData()
      // },
      // 获取审批表原内容
      getApplyData() {
        this.hasApplyId = this.form.applyId ? true : false
        // this.form.applyId = this.$route.params.applyId
        if (this.form.applyId) {
          this.formLoading = true
          this.getProjectApplyInfo()
        } else {
          this.setSelectArr(this.applyInfo, 14, this.form.type / 1)
        }
      },
      // 获取原审批表内容
      getProjectApplyInfo() {
        ajax.get('/gc/project/pay/apply/info/' + this.form.applyId, '', (res) => {
          this.applyInfo = res.vo

          this.form.name = this.applyInfo.name
          this.form.payTypeId = this.applyInfo.payTypeId
          this.form.type = this.applyInfo.type
          this.form.bcjk = this.applyInfo.bcjk
          this.form.bqshjk = this.applyInfo.bqshjk
          this.form.bqzf = this.applyInfo.bqzf
          this.form.fkdw = this.applyInfo.fkdw
          this.form.htdf = this.applyInfo.htdf
          this.form.htjk = this.applyInfo.htjk
          this.form.htmc = this.applyInfo.htmc
          this.form.jbr = this.applyInfo.jbr
          this.form.kxlb = this.applyInfo.kxlb
          this.form.ljzfjk = this.applyInfo.ljzfjk
          this.form.wtfs = this.applyInfo.wtfs
          this.form.xmgldw = this.applyInfo.xmgldw
          this.form.zfqs = this.applyInfo.zfqs
          this.form.zfzshzj = this.applyInfo.zfzshzj
          this.remark = this.form.remark = this.applyInfo.remark

          this.form.htqx = this.applyInfo.htqx
          this.form.cgfs = this.applyInfo.cgfs
          this.form.bcht1 = this.applyInfo.bcht1
          this.form.bcht2 = this.applyInfo.bcht2
          this.form.ywchtje = this.applyInfo.ywchtje
          this.form.bqcgje = this.applyInfo.bqcgje

          this.form.dxje = this.applyInfo.dxje

          if (this.form.type == 5) {
            this.contractType = '3'
          } else if (this.form.type == 6) {
            this.contractType = '4'
          } else if (this.form.type == 2 || this.form.type == 3) {
            this.contractType = '2'
          }

          // 是否独立支付支付相关Type
          this.form.isSinglePay = this.applyInfo.project ? 0 : 1

          // 是否线下通过审批
          this.form.underLine = this.applyInfo.underLine.toString()

          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []

          this.setSelectArr(this.applyInfo, 14, this.form.type / 1)
          this.formLoading = false
        })
      },
      // 提交申请
      createProject() {

        if (this.$refs.create.getFromData()) {
          this.form = this.$refs.create.getFromData()
        } else {
          return
        }

        // 赋值合同ID
        this.form.contractId = this.project.contractId

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        this.form.attachments = this.$refs.attachments.getAttachments()

        console.log(this.form.approvalUserIds)
        // return

        this.formLoading = true
        let _url = !this.form.applyId ? '/gc/project/pay/apply' : '/gc/project/pay/apply/edit'

        ajax.post(_url, this.form, (res) => {
          this.$message.success("提交项目款项支付审批成功，请耐心等待领导审批")
          this.$router.back()
          this.formLoading = false
        }, (res) => {
          this.formLoading = false
        })
      },
    },
    watch: {
      'contractType'() {
        if (this.contractType != 4) {
          this.form.remark = ""
        }

        if (this.contractType == 4) {
          if (!this.form.applyId) {
            this.form.remark = ""
          }
          // 原水资金使用
          // if (!this.form.fkdw) {
          this.form.fkdw = this.userData.childDept
          // }
          this.form.type = 6
        } else if (this.contractType == 2) {
          if (this.form.remark == "") {
            this.form.remark = '根据合同款中约定，“    ”，经审核，本期付款金额为（大写）  元整  （小写￥    元），申请予以支付。'
          }
          // 子公司
          if (this.userData.deptDetail) {
            // 原水
            this.form.type = 3
          } else {
            // 通用子公司
            this.form.type = 2
          }
        } else if (this.contractType == 3) {
          // 设备与采购
          if (this.form.remark == "") {
            this.form.remark = '按合同规定，产品验收合格后支付货款的70%，本期应付材料款： ×70%= 元。（大写金额： ）'
          }
          this.form.type = 5
        } else {
          if (this.form.remark == "") {
            this.form.remark = '根据合同款中约定，“    ”，经审核，本期付款金额为（大写）  元整  （小写￥    元），申请予以支付。'
          }
          if (this.userData.deptDetail) {
            // 原水集团
            this.form.type = 1
          } else {
            // 通用集团
            this.form.type = 0
          }
        }
        if (this.remark) {
          this.form.remark = this.remark
        }


      },
      'form.type'() {
        // console.log(this.form.type)

        this.approvalUsersData = this.approvalUsers['c14_' + this.form.type]
        this.setSelectArr(this.applyInfo, 14, this.form.type / 1)
      },
    }
  };

</script>



// WEBPACK FOOTER //
// src/page/pay/createPayApproval.vue